import styled from "styled-components";

export const TagsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.sm || "8px"};
  width: 100%;
  padding: 0 ${(props) => props.theme.spacing?.xxl || "24px"};
  padding-bottom: ${(props) => props.theme.spacing?.xxl || "24px"};
`;

export const AddTagsButtonTop = styled.div`
  display: flex;
  align-items: center;
`;

export const TagsInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.sm || "8px"};
  width: 100%;
`;

export const TagsInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.sm || "8px"};
  width: 100%;
`;

export const InputWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.xs || "4px"};
  flex-shrink: 0;
`;

export const TooltipTrigger = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.xs || "4px"};
  width: 100%;
  min-width: 0;
`;

export const TagsItems = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.xs || "4px"};
  flex: 1;
  min-width: 0;

  /* mantiene todo en una sola fila */
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

export const TagsActions = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const AddTagsButtonBottom = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0;
`;
